import * as React from 'react';
import mergeRefs from '../utils/mergeRefs.js';

/**
 * Custom hook which creates a new callback ref that effectively merges all provided `refs`
 * @param refs
 */
function useMergedRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return React.useCallback(mergeRefs.apply(void 0, refs), refs);
}

export { useMergedRefs as default };
//# sourceMappingURL=useMergedRefs.js.map
